var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowPasswordChecker)?_c('password-checker',{on:{"check":_vm.checkDevAuth}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }